import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-white pt-16 pb-8 border-t border-gray-200" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">

        {/* TOP FOOTER */}
        <div className="flex flex-col md:flex-row justify-between gap-10 mb-12" data-id="element-138">

          {/* LEFT */}
          <div className="max-w-md" data-id="element-139">
            <a href="#" className="flex items-center gap-2 mb-4" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/guu75Bs7Tjxnk8JqJWnwYN/Logo.png" alt="Tokoteta Logo" className="h-9 w-auto object-contain" data-id="element-141" />
            </a>

            <p className="text-text-muted text-sm leading-relaxed" data-id="element-142">
              {t.footer.description}
            </p>
          </div>

          {/* RIGHT - SOCIAL */}
          <div className="flex items-start md:items-end justify-start md:justify-end" data-id="element-143">
            <div className="flex items-center gap-6" data-id="element-144">
              <a href="https://www.instagram.com/tokoteta.id/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="transition-all duration-200 hover:scale-110 hover:opacity-80" data-id="element-145">
                <img src="https://cdn.magicpatterns.com/uploads/dP56Yec5nxKrAJzt1bHUxY/Social_icon.png" alt="Instagram" className="w-7 h-7 object-contain" data-id="element-146" />
              </a>

              <a href="https://www.tiktok.com/@tokoteta.id" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="transition-all duration-200 hover:scale-110 hover:opacity-80" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/qyyj9uKfTqL7Ggra7JQVsi/Social_icon_(1).png" alt="TikTok" className="w-7 h-7 object-contain" data-id="element-148" />
              </a>
            </div>
          </div>

        </div>

        {/* BOTTOM FOOTER */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-149">
          <p className="text-text-muted text-sm" data-id="element-150">
            © {new Date().getFullYear()} Tokoteta. {t.footer.rights}
          </p>
        </div>

      </div>
    </footer>;
}